import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarUserInfo from './SidebarUserInfo'

const SidebarTicketUserSection = ({ userName, userAvatarUrl }) => {
  const { t } = useTranslation()

  if (!userName) {
    return null
  }

  return (
    <SidebarSection title={t('sidebar.userSection')} copyText={userName}>
      <SidebarUserInfo
        name={userName}
        avatarUrl={userAvatarUrl}
      />
    </SidebarSection>
  )
}

SidebarTicketUserSection.propTypes = {
  userName: PropTypes.string,
  userAvatarUrl: PropTypes.string,
}

export default SidebarTicketUserSection
